import { createAuthClient } from 'better-auth/client';
import { organizationClient } from 'better-auth/client/plugins';
import { environment } from '../../../environments/environment.js';

export const authClient = createAuthClient({
  baseURL: environment.neonAuthUrl,
  plugins: [organizationClient()],
});
